"use client";
import React from "react";

const galleryImages = [
  {
    src: "/assets/images/3299B497-290C-4D15-9053-C9575D70E5D9_2-1774626489871.jpg",
    alt: "Basket full of Pick Me Up cookie packages",
  },
  {
    src: "/assets/images/IMG_0235-1774625699808.jpg",
    alt: "Woman in a black leather jacket holding a Pick Me Up cookie package in a café",
  },
  {
    src: "/assets/images/IMG_3388-1774626150998.jpg",
    alt: "Blonde woman eating a Pick Me Up chocolate chip cookie",
    style: { filter: "brightness(1.3)" },
  },
  {
    src: "/assets/images/IMG_2134-1774629059502.jpg",
    alt: "Pick Me Up cookie package next to a latte at Babu\'s cafe",
  },
  {
    src: "/assets/images/IMG_0212-1774625354517.jpg",
    alt: "Person holding a Pick Me Up cookie in a café setting",
  },
  {
    src: "/assets/images/IMG_3387_2-1774627520494.jpg",
    alt: "Blonde woman in a cream cardigan opening a Pick Me Up cookie package in a café",
    style: { filter: "brightness(1.3)" },
  },
  {
    src: "/assets/images/IMG_0521-1774625367159.jpg",
    alt: "Flatlay with Pick Me Up cookie package on a table with lifestyle props",
  },
  {
    src: "/assets/images/IMG_9740-1774628242097.jpg",
    alt: "Crowd at an event with someone holding up Pick Me Up cookie packages in the foreground",
  },
];

export default function PhotoGalleryStrip() {
  return (
    <section className="w-full pt-[72px] mb-0">
      {/* Mobile: 2×4 grid */}
      <div className="grid grid-cols-4 md:hidden">
        {galleryImages?.map((image, index) => (
          <div key={index} className="w-full">
            <img
              src={image?.src}
              alt={image?.alt}
              className="w-full h-24 object-cover"
              style={image?.style ?? {}}
            />
          </div>
        ))}
      </div>

      {/* Tablet: horizontally scrollable strip with fixed-width tiles */}
      <div className="hidden md:flex lg:hidden overflow-x-auto">
        {galleryImages?.map((image, index) => (
          <div key={index} className="flex-shrink-0" style={{ width: "160px" }}>
            <img
              src={image?.src}
              alt={image?.alt}
              className="w-full h-32 object-cover"
              style={image?.style ?? {}}
            />
          </div>
        ))}
      </div>

      {/* Desktop: original equal-width strip */}
      <div className="hidden lg:flex">
        {galleryImages?.map((image, index) => (
          <div
            key={index}
            className="flex-shrink-0"
            style={{ width: `${100 / galleryImages?.length}%` }}
          >
            <img
              src={image?.src}
              alt={image?.alt}
              className="w-full h-32 object-cover"
              style={image?.style ?? {}}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
